var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">\n", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1214 16.0004L24.0589 10.0629C24.3407 9.78161 24.4992 9.39989 24.4996 9.00173C24.4999 8.60357 24.3421 8.22157 24.0608 7.93978C23.7795 7.65799 23.3978 7.49948 22.9996 7.49913C22.6014 7.49878 22.2195 7.65661 21.9377 7.9379L16.0002 13.8754L10.0627 7.9379C9.78087 7.65611 9.39868 7.4978 9.00016 7.4978C8.60165 7.4978 8.21945 7.65611 7.93766 7.9379C7.65587 8.2197 7.49756 8.60189 7.49756 9.0004C7.49756 9.39892 7.65587 9.78111 7.93766 10.0629L13.8752 16.0004L7.93766 21.9379C7.65587 22.2197 7.49756 22.6019 7.49756 23.0004C7.49756 23.3989 7.65587 23.7811 7.93766 24.0629C8.21945 24.3447 8.60165 24.503 9.00016 24.503C9.39868 24.503 9.78087 24.3447 10.0627 24.0629L16.0002 18.1254L21.9377 24.0629C22.2195 24.3447 22.6016 24.503 23.0002 24.503C23.3987 24.503 23.7809 24.3447 24.0627 24.0629C24.3445 23.7811 24.5028 23.3989 24.5028 23.0004C24.5028 22.6019 24.3445 22.2197 24.0627 21.9379L18.1214 16.0004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.224cee3dba923a8e4172057aae3cd3fb.svg";
export { ForwardRef as ReactComponent };